export enum ManualGasXTransfertStatus {
  DONE,
  IN_PROGRESS,
  ERROR,
  CANCELLING,
  CANCELED
}

export interface ManualGasXTransfert {
  date: string;
  status: ManualGasXTransfertStatus;
  startInterval?: string;
  endInterval?: string;
  nbrSteps?: number;
  currentStep?: number;
  user: string;
}
